import { render, staticRenderFns } from "./BodyMenu.vue?vue&type=template&id=0c70b47d&scoped=true"
import script from "./BodyMenu.vue?vue&type=script&lang=js"
export * from "./BodyMenu.vue?vue&type=script&lang=js"
import style0 from "./BodyMenu.vue?vue&type=style&index=0&id=0c70b47d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70b47d",
  null
  
)

export default component.exports